import { render, staticRenderFns } from "./FormTextAreaFormatter.vue?vue&type=template&id=747315ea"
import script from "./FormTextAreaFormatter.vue?vue&type=script&lang=js"
export * from "./FormTextAreaFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports